var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center mb-3"},[_c('span',{staticClass:"text-h5"},[_vm._v(_vm._s(_vm.title))]),_c('v-spacer'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }